// @flow 
import * as React from 'react';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Search, SearchForwardRef, SearchProps, SearchState } from './FilterComponents/Search';
import { AnyFilter, Filter, FilterForwardRef, FilterState } from './FilterComponents/Filters';
import { GridState } from 'ag-grid-enterprise';
import { JsxElement } from 'typescript';


export type AgGridToolbarProps = {
    className?: string;
    style?: React.CSSProperties;

    search?: boolean;
    searchProps?: Omit<SearchProps, 'onSearch'>;
    
    filters?: AnyFilter[];
    children?: React.ReactNode;
    handleSubmit?: (searchState?: SearchState, filterState?: FilterState) => void;
    handleClearFilters?: () => void;
    handleFilterOpen?: () => void;
};

export type AgGridToolbarRef = {
    saveFilters: () => Map<string, any>;
    loadFilters: (filters: Map<string, any>) => void;
};

export const AgGridToolbar = forwardRef<AgGridToolbarRef, AgGridToolbarProps>((props: AgGridToolbarProps, ref) => {
    const searchRef = useRef<SearchForwardRef>();
    const filtersRef = useRef<FilterForwardRef>();

    useImperativeHandle(ref, () => ({
        loadFilters: (filters: Map<string, any>) => {
            filtersRef.current?.loadFilters(filters);
        },
        saveFilters: () => {
            return filtersRef.current!.saveFilters();
        }
    }));
    
    function onSearch(searchStateSent?: SearchState, filterStateSent?: FilterState) {
        const searchState = searchStateSent ?? searchRef.current?.getSearchState();
        const filterState = filterStateSent ?? filtersRef.current?.getAppliedFilters();
        props.handleSubmit && props.handleSubmit(searchState, filterState);
    }

    function onClearFilters(){
        props.handleClearFilters && props.handleClearFilters();
    }

    function onFilterOpened(){
        props.handleFilterOpen && props.handleFilterOpen();
    }

    function buttonColumnWidth(): number{
        return 12 - (props.filters ? 2 : 0) - (props.search ? 4: 0);
    }
    
    return (
        <div className={props.className + " row-no-gutters"}>
            <Row>
                {props.search ? <Col xs={4} className='px-0'>
                    <Search
                        ref={searchRef}
                        mainSearchClass='me-1'
                        onSearch={(e) => onSearch(e, undefined)}
                        {...props.searchProps}
                    />
                </Col> : <></>}
                {props.filters ? <Col xs={2} className='px-0'>
                    <Filter
                        ref={filtersRef}
                        onFilterApplied={(e) => onSearch(undefined, e)}
                        onFilterCleared={() => onClearFilters()}
                        filters={props.filters}
                        onOpen={()=>onFilterOpened()}
                    />
                </Col> : <></>}
                {props.children ? <Col xs={buttonColumnWidth()} className='px-0 d-inline-flex justify-content-end'>
                    {props.children}
                </Col> : <></>}
            </Row>
        </div>
    );
}
);